import { logOut } from "../../utils";
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { getMenu, selectMenu } from "../../store/slice/manager/menu";
import { FaBullhorn, FaRegBuilding } from "react-icons/fa";
import styles from "./style/Navigation.module.scss";
import {
  MdTimeline,
  MdFactCheck,
  MdOutlineApi,
  MdManageAccounts,
  MdMiscellaneousServices,
  MdBusiness,
  MdDashboard,
  MdEvent,
  MdOutlineMenuBook,
  MdOutlineMap,
  MdKeyboardArrowDown,
  MdReceiptLong,
  MdChatBubbleOutline,
  MdShoppingCart,
  MdOutlinePayments,
  MdOutlineContactMail,
} from "react-icons/md";
import { BiCalendarStar, BiGrid } from "react-icons/bi";
import { ImCircleLeft, ImCircleRight } from "react-icons/im";
import Button from "../Utilities/Button";
import { useSelector, useDispatch } from "react-redux";
import {
  selectLeftNavigate,
  editModeToggleHandler,
  toggleOn,
  toggleOff,
} from "../../store/slice/navigate";
import { selectPermissionSettings } from "../../store/slice/permissionSettings";
import { selectEnterprise } from "../../store/slice/enterpriseLists";
import { getServiceName } from "../../constant/SERVICE_NAME_MAP";
import { VscGlobe } from "react-icons/vsc";
import { FaPeopleGroup } from "react-icons/fa6";
import { RiRobot2Line } from "react-icons/ri";
import { BsFillPersonLinesFill } from "react-icons/bs";
import { FiFileText } from "react-icons/fi";
import { LuCommand } from "react-icons/lu";

const LeftNavigation = () => {
  const params = useParams();

  const location = useLocation();
  const dispatch = useDispatch();
  const { menu } = useSelector(selectMenu);
  // 之後再把 menu 裡面新增 績效管理

  const { auth } = useSelector(selectPermissionSettings);

  const { isEnterprise } = useSelector(selectEnterprise);

  const [isToggleOn, setIsToggleOn] = useState(false);
  const [menuAdminIndex, setMenuAdminIndex] = useState(0);
  const [menuFilter, setMenuFilter] = useState([]);
  const [keystoneOpenGroups, setKeystoneOpenGroups] = useState({
    activity: true,
    announcement: true,
    registration: true,
    finance: true,
  });
  const { navigateEditMode } = useSelector(selectLeftNavigate);
  const toggleLeftNavigation = useSelector(selectLeftNavigate);
  const leftNavigationShow = toggleLeftNavigation.toggleOpen;

  useEffect(() => {
    dispatch(getMenu());
  }, [dispatch]);

  const handleShowList = (index) => {
    setMenuAdminIndex(index);
    if (index === 0) {
      if (isToggleOn === false) {
        setIsToggleOn(true);
      } else if (isToggleOn === true && menuAdminIndex === index) {
        setIsToggleOn(false);
      }
    }
  };

  const handleShowLeftBar = () => {
    if (leftNavigationShow === false) {
      dispatch(toggleOn());
    } else {
      dispatch(toggleOff());
    }
  };

  useEffect(() => {
    // 依權限動態顯示服務：只要該服務（以 sys_alias 對應）有 enterprise.view_enterprise_list
    // 權限就顯示，不再寫死只有 id 2 / 7。
    // 注意：sys_alias 之間有子字串關係（例如 "tdp" 是 "tdp_performance" 的前綴），
    //       所以比對權限字串的第一個 segment，不能用 includes()，避免誤判。
    const hasServiceListPermission = (sysAlias) =>
      !!sysAlias &&
      auth?.workspace_permissions?.some((workspace) =>
        workspace.permissions?.some(
          (permission) =>
            permission.split(".")[0] === sysAlias &&
            permission.includes("enterprise.view_enterprise_list")
        )
      );

    const filterMenu = menu?.filter((data) =>
      hasServiceListPermission(data.sys_alias)
    );
    setMenuFilter(filterMenu || []);
  }, [menu, auth]);

  const menuAdmin = [
    {
      id: 1,
      name: "服務管理",
      icon: <MdMiscellaneousServices className={styles.serviceIcon} />,
      link: "/admin/services",
    },
    {
      id: 2,
      name: "企業帳號管理",
      icon: <FaRegBuilding className={styles.serviceIcon} />,
      link: "/admin/company-system",
    },
    {
      id: 3,
      name: "企業購買委託單",
      icon: <MdShoppingCart className={styles.serviceIcon} />,
      link: "/admin/keystone/purchases",
    },
    {
      id: 4,
      name: "個人帳號管理",
      icon: <FaPeopleGroup className={styles.serviceIcon} />,
      link: "/personal-accounts/lists",
    },
    {
      id: 5,
      name: "個人訂閱管理",
      icon: <MdOutlinePayments className={styles.serviceIcon} />,
      link: "/admin/keystone/personal-subscriptions",
    },
    {
      id: 6,
      name: "Workspace",
      icon: <MdDashboard className={styles.serviceIcon} />,
      link: "/admin/workspace",
    },
  ];

  const menuAdminRegistration = [
    {
      id: "admin-consultations",
      name: "諮詢管理",
      icon: <MdChatBubbleOutline className={styles.serviceIcon} />,
      link: "/admin/keystone/consultations",
    },
    {
      id: "admin-signup-list",
      name: "報名列表",
      icon: <BsFillPersonLinesFill className={styles.serviceIcon} />,
      link: "/admin/form/signed",
    },
    {
      id: "admin-start-one-signup",
      name: "START-ONE 報名",
      icon: <RiRobot2Line className={styles.serviceIcon} />,
      link: "/admin/form/ai-agent",
    },
  ];

  const isWorkspaceAdminEmail =
    !!auth?.roles?.find((item) => item === "workspace.admin") &&
    auth?.email === "workspace.admin@adbert.com.tw";

  // 諮詢管理（/admin/keystone/consultations）：除 workspace.admin 外，另開放 marketing 帳號。
  // 僅放行「諮詢管理」這一項；報名列表 / START-ONE 報名等其餘項目仍限 workspace.admin。
  const canAccessConsultations =
    isWorkspaceAdminEmail ||
    auth?.email === "workspace+marketing@adbert.com.tw";

  const menuTDP = [
    {
      id: 0,
      name: "總覽",
      icon: <MdDashboard className={styles.serviceIcon} />,
      link: "/dashboard/tdp/menu",
      group: "menu",
    },
    {
      id: 1,
      name: "語言設定",
      icon: <VscGlobe className={styles.serviceIcon} />,
      group: "language",
      link: "/dashboard/tdp/language",
    },
    {
      id: 2,
      name: "企業產業類別",
      icon: <MdBusiness className={styles.serviceIcon} />,
      group: "category",
      link: "/dashboard/tdp/category/main",
    },
    {
      id: 3,
      name: "經營藍圖模板",
      icon: <MdOutlineMap className={styles.serviceIcon} />,
      group: "blueprint",
      link: "/dashboard/tdp/blueprint/goal",
    },
    {
      id: 4,
      name: "企業生命週期",
      icon: <MdTimeline className={styles.serviceIcon} />,
      group: "life-cycle",
      link: "/dashboard/tdp/life-cycle",
      submenu: menu,
    },
    {
      id: 5,
      name: "PAEI",
      group: "PAEI-setting",
      icon: <MdFactCheck className={styles.serviceIcon} />,
      link: "/dashboard/tdp/PAEI-setting/practical",
    },
    {
      id: 6,
      name: "人才九宮格",
      group: "personal-talent",
      icon: <BiGrid className={styles.serviceIcon} />,
      link: "/dashboard/tdp/personal-talent",
    },
    {
      id: 7,
      name: "ASK",
      group: "ask",
      icon: <MdOutlineApi className={styles.serviceIcon} />,
      link: "/dashboard/tdp/ask/attitude",
    },
    {
      id: 8,
      name: "企業主管理",
      icon: <MdManageAccounts className={styles.serviceIcon} />,
      link: "#",
    },
    {
      id: 9,
      name: "企業案例",
      group: "tdp/enterprise",
      icon: <MdOutlineMenuBook className={styles.serviceIcon} />,
      link: "/dashboard/tdp/enterprise",
    },
    {
      id: 10,
      name: "活動管理",
      group: "tdp/events",
      icon: <MdEvent className={styles.serviceIcon} />,
      link: "/dashboard/tdp/events",
    },
    {
      id: 11,
      name: "報名人員列表",
      group: "tdp/events/registrations",
      icon: <BsFillPersonLinesFill className={styles.serviceIcon} />,
      link: "/dashboard/tdp/events/registrations",
    },
    {
      id: 12,
      name: "活動花絮",
      group: "tdp/events/highlights",
      icon: <BiCalendarStar className={styles.serviceIcon} />,
      link: "/dashboard/tdp/events/highlights",
    },
    {
      id: 13,
      name: "發行日記",
      group: "tdp/release-notes",
      icon: <FiFileText className={styles.serviceIcon} />,
      link: "/dashboard/tdp/release-notes",
    },
    {
      id: 14,
      name: "系統公告",
      group: "tdp/system-announcements",
      icon: <FaBullhorn className={styles.serviceIcon} />,
      link: "/dashboard/tdp/system-announcements",
    },
    {
      id: 15,
      name: "發票管理",
      group: "tdp/finance/invoices",
      icon: <MdReceiptLong className={styles.serviceIcon} />,
      link: "/dashboard/tdp/finance/invoices",
    },
  ];

  const keystonePrimaryGroups = [
    "menu",
    "language",
    "category",
    "blueprint",
    "life-cycle",
  ];

  const keystoneStartOneMenu = [
    {
      id: "start-one-signup",
      name: "START-ONE 報名",
      icon: <RiRobot2Line className={styles.serviceIcon} />,
      link: "/admin/form/ai-agent",
      group: "start-one",
    },
    {
      id: "start-one-list",
      name: "報名列表",
      icon: <BsFillPersonLinesFill className={styles.serviceIcon} />,
      link: "/admin/form/signed",
      group: "start-one",
    },
    {
      id: "start-one-ai-learning-resources",
      name: "AI 智庫",
      icon: <FiFileText className={styles.serviceIcon} />,
      link: "/dashboard/tdp/ai-learning-resources",
      group: "start-one",
    },
    {
      id: "start-one-ai-wave-leads",
      name: "AI WAVE 展場名單",
      icon: <MdOutlineContactMail className={styles.serviceIcon} />,
      link: "/dashboard/tdp/ai-wave/leads",
      group: "start-one",
    },
    {
      id: "start-one-recommended-prompts",
      name: "推薦提示詞",
      icon: <LuCommand className={styles.serviceIcon} />,
      link: "/dashboard/tdp/recommended-prompts",
      group: "start-one",
    },
  ];

  const tdpActivityMenu = menuTDP.filter((item) =>
    ["tdp/events", "tdp/events/registrations", "tdp/events/highlights"].includes(
      item.group
    )
  );
  const tdpAnnouncementMenu = menuTDP.filter((item) =>
    ["tdp/system-announcements", "tdp/release-notes"].includes(item.group)
  );
  const tdpFinanceMenu = menuTDP.filter((item) =>
    ["tdp/finance/invoices"].includes(item.group)
  );
  const tdpKeystonePrimaryMenu = menuTDP.filter((item) =>
    keystonePrimaryGroups.includes(item.group)
  );
  const tdpKeystoneSecondaryMenu = menuTDP.filter(
    (item) =>
      ![
        ...keystonePrimaryGroups,
        "tdp/events",
        "tdp/events/registrations",
        "tdp/events/highlights",
        "tdp/system-announcements",
        "tdp/release-notes",
        "tdp/finance/invoices",
      ].includes(item.group)
  );

  const TDP_MARKETING_EMAIL = "workspace+marketing@adbert.com.tw";
  const TDP_CEO_EMAIL = "workspace+ceo@adbert.com.tw";
  const TDP_AI_EMAIL = "workspace+ai@adbert.com.tw";
  const TDP_FINANCE_EMAIL = "workspace+finance@adbert.com.tw";

  const tdpEmail = auth?.email;
  const isTdpRestricted =
    tdpEmail === TDP_MARKETING_EMAIL ||
    tdpEmail === TDP_CEO_EMAIL ||
    tdpEmail === TDP_AI_EMAIL ||
    tdpEmail === TDP_FINANCE_EMAIL;
  const isFinance = tdpEmail === TDP_FINANCE_EMAIL;
  const isWorkspaceAdmin = !!auth?.roles?.find(
    (r) => r === "workspace.admin"
  );

  const tdpStartOneAllowedIds = {
    [TDP_MARKETING_EMAIL]: new Set([
      "start-one-signup",
      "start-one-list",
      "start-one-ai-learning-resources",
      "start-one-ai-wave-leads",
    ]),
    [TDP_CEO_EMAIL]: new Set(["start-one-recommended-prompts"]),
    [TDP_AI_EMAIL]: new Set(),
    [TDP_FINANCE_EMAIL]: new Set(),
  };

  const tdpKeystoneAllowedGroups = {
    [TDP_MARKETING_EMAIL]: new Set(["tdp/enterprise"]),
    [TDP_CEO_EMAIL]: new Set(),
    [TDP_AI_EMAIL]: new Set(),
    [TDP_FINANCE_EMAIL]: new Set(),
  };

  const filteredKeystoneStartOneMenu = isTdpRestricted
    ? keystoneStartOneMenu.filter((item) =>
        tdpStartOneAllowedIds[tdpEmail].has(item.id)
      )
    : keystoneStartOneMenu;

  const showTdpActivitySection =
    !isTdpRestricted || tdpEmail === TDP_MARKETING_EMAIL;
  const showTdpAnnouncementSection =
    !isTdpRestricted || tdpEmail === TDP_MARKETING_EMAIL;
  const showTdpFinanceSection = isWorkspaceAdmin || isFinance;

  const filteredTdpKeystoneMenu = isTdpRestricted
    ? [...tdpKeystonePrimaryMenu, ...tdpKeystoneSecondaryMenu].filter((item) =>
        tdpKeystoneAllowedGroups[tdpEmail].has(item.group)
      )
    : [...tdpKeystonePrimaryMenu, ...tdpKeystoneSecondaryMenu];

  const navigate = useNavigate();

  const handleClickEnterpriseLink = (e, to) => {
    if (to === "/dashboard/tdp/enterprise") {
      return;
    }
    if (isEnterprise) {
      e.preventDefault();
      const userConfirmed = window.confirm("是否離開編輯畫面？");

      if (userConfirmed) {
        navigate(to);
      }
    }
  };

  const toggleKeystoneGroup = (groupKey) => {
    setKeystoneOpenGroups((prev) => ({
      ...prev,
      [groupKey]: !prev[groupKey],
    }));
  };

  const isTdpItemActive = (item) => {
    if (item.group === "tdp/events") {
      return location.pathname === "/dashboard/tdp/events";
    }
    return location.pathname.includes(item.group);
  };

  return (
    <>
      {leftNavigationShow ? (
        <ImCircleLeft
          cursor='pointer'
          onClick={handleShowLeftBar}
          className={styles.leftIcon}
        />
      ) : (
        <ImCircleRight
          cursor='pointer'
          onClick={handleShowLeftBar}
          className={styles.rightIcon}
        />
      )}
      <div
        className={styles.leftNavigation}
        style={{ display: leftNavigationShow ? "block" : "none" }}>
        <div className={styles.title}>
          {auth?.roles.find((item) => item === "workspace.admin")
            ? "KEYSTONE CLOUD"
            : "KEYSTONE 中控系統"}
        </div>

        <div className={styles.naviTop}>
          {isWorkspaceAdminEmail &&
            menuAdmin.map((data, index) => (
              <div key={index} className={styles.list}>
                <Link to={data.link}>
                  <div
                    onClick={() => setMenuAdminIndex(index)}
                    className={`${styles.serviceBtn} ${
                      ((index === 0 &&
                        location.pathname.includes("/admin/services")) ||
                        (index !== 0 &&
                          data.link.includes(location.pathname))) &&
                      styles.active
                    }`}>
                    {data.icon}
                    <div className={styles.serviceBtnContent}>{data.name}</div>
                  </div>
                </Link>
              </div>
            ))}

          {auth?.roles?.find((item) => item === "workspace.user") &&
            !auth?.roles?.find((item) => item === "workspace.admin") && (
              <>
                {menuFilter?.map((menu, index) => (
                  <Link to={`/dashboard/business/${menu.id}`} key={index}>
                    <div
                      className={`${styles.serviceBtn} ${
                        menu.id === parseInt(params.id) &&
                        !location.pathname.includes("enterprise-list") &&
                        styles.active
                      }`}>
                      <div className={styles.serviceBtnContent}>
                        {getServiceName(menu.name)}
                      </div>
                    </div>
                  </Link>
                ))}

                <hr
                  style={{ border: "none", borderBottom: "1px solid #cccccc" }}
                />

                {auth?.workspace_permissions?.length > 0 && (
                  <Link to={"/enterprise-list"}>
                    <div
                      onClick={() => setMenuAdminIndex(1)}
                      className={`${styles.serviceBtn} ${
                        location.pathname.includes("enterprise-list") &&
                        styles.active
                      }`}>
                      <FaRegBuilding className={styles.serviceIcon} />
                      <div className={styles.serviceBtnContent}>
                        企業帳號管理
                      </div>
                    </div>
                  </Link>
                )}
                {/* <Link to={"/personal-accounts"}>
                  <div
                    onClick={() => setMenuAdminIndex(1)}
                    className={`${styles.serviceBtn} ${
                      location.pathname.includes("personal-accounts") &&
                      styles.active
                    }`}>
                    <FaPeopleGroup className={styles.serviceIcon} />
                    <div className={styles.serviceBtnContent}>個人帳號管理</div>
                  </div>
                </Link> */}
                {auth?.workspace_permissions?.length > 0 && (
                  <Link to={"/admin/workspace"}>
                    <div
                      onClick={() => setMenuAdminIndex(1)}
                      className={`${styles.serviceBtn} ${
                        location.pathname.includes("admin/workspace") &&
                        styles.active
                      }`}>
                      <MdDashboard className={styles.serviceIcon} />
                      <div className={styles.serviceBtnContent}>Workspace</div>
                    </div>
                  </Link>
                )}
              </>
            )}

          {auth?.roles?.find((item) => item === "workspace.tdp") && (
            <>
              {filteredKeystoneStartOneMenu.length > 0 && (
                <div className={styles.sectionDividerTitle}>START-ONE</div>
              )}
              {filteredKeystoneStartOneMenu.map((data) => (
                <div
                  key={data.id}
                  className={styles.list}
                  onClick={() => {
                    if (navigateEditMode) {
                      dispatch(editModeToggleHandler(true));
                    }
                  }}>
                  {!navigateEditMode && (
                    <Link to={data.link}>
                      <div
                        onClick={() => handleShowList(0)}
                        className={`${styles.serviceBtn} ${
                          location.pathname.includes(data.link) && styles.active
                        }`}>
                        {data.icon}
                        <div className={styles.serviceBtnContent}>{data.name}</div>
                      </div>
                    </Link>
                  )}
                  {navigateEditMode && (
                    <div
                      onClick={() => handleShowList(0)}
                      className={`${styles.serviceBtn} ${
                        location.pathname.includes(data.link) && styles.active
                      }`}>
                      {data.icon}
                      <div className={styles.serviceBtnContent}>{data.name}</div>
                    </div>
                  )}
                </div>
              ))}

              {showTdpActivitySection && (
                <div
                  className={styles.groupHeader}
                  onClick={() => toggleKeystoneGroup("activity")}>
                  <div className={styles.groupHeaderTitle}>活動管理</div>
                  <MdKeyboardArrowDown
                    className={`${styles.groupHeaderIcon} ${
                      keystoneOpenGroups.activity ? styles.groupHeaderOpen : ""
                    }`}
                  />
                </div>
              )}
              {showTdpActivitySection &&
                keystoneOpenGroups.activity &&
                tdpActivityMenu.map((data, index) => (
                  <div
                    key={data.id}
                    className={styles.list}
                    onClick={() => {
                      if (navigateEditMode) {
                        dispatch(editModeToggleHandler(true));
                      }
                    }}>
                    {!navigateEditMode && (
                      <Link to={data.link}>
                        <div
                          onClick={(e) => {
                            handleShowList(index);
                            handleClickEnterpriseLink(e, data.link);
                          }}
                          className={`${styles.serviceBtn} ${
                            isTdpItemActive(data) && styles.active
                          }`}>
                          {data.icon}
                          <div className={styles.serviceBtnContent}>
                            {data.name}
                          </div>
                        </div>
                      </Link>
                    )}
                    {navigateEditMode && (
                      <div
                        onClick={() => {
                          handleShowList(index);
                        }}
                        className={`${styles.serviceBtn} ${
                          isTdpItemActive(data) && styles.active
                        }`}>
                        {data.icon}
                        <div className={styles.serviceBtnContent}>{data.name}</div>
                      </div>
                    )}
                  </div>
                ))}

              {showTdpAnnouncementSection && (
                <div
                  className={styles.groupHeader}
                  onClick={() => toggleKeystoneGroup("announcement")}>
                  <div className={styles.groupHeaderTitle}>公告管理</div>
                  <MdKeyboardArrowDown
                    className={`${styles.groupHeaderIcon} ${
                      keystoneOpenGroups.announcement ? styles.groupHeaderOpen : ""
                    }`}
                  />
                </div>
              )}
              {showTdpAnnouncementSection &&
                keystoneOpenGroups.announcement &&
                tdpAnnouncementMenu.map((data, index) => (
                  <div
                    key={data.id}
                    className={styles.list}
                    onClick={() => {
                      if (navigateEditMode) {
                        dispatch(editModeToggleHandler(true));
                      }
                    }}>
                    {!navigateEditMode && (
                      <Link to={data.link}>
                        <div
                          onClick={(e) => {
                            handleShowList(index);
                            handleClickEnterpriseLink(e, data.link);
                          }}
                          className={`${styles.serviceBtn} ${
                            isTdpItemActive(data) && styles.active
                          }`}>
                          {data.icon}
                          <div className={styles.serviceBtnContent}>
                            {data.name}
                          </div>
                        </div>
                      </Link>
                    )}
                    {navigateEditMode && (
                      <div
                        onClick={() => {
                          handleShowList(index);
                        }}
                        className={`${styles.serviceBtn} ${
                          isTdpItemActive(data) && styles.active
                        }`}>
                        {data.icon}
                        <div className={styles.serviceBtnContent}>{data.name}</div>
                      </div>
                    )}
                  </div>
                ))}

              {filteredTdpKeystoneMenu.length > 0 && (
                <div className={styles.sectionDividerTitle}>Keystone</div>
              )}
              {filteredTdpKeystoneMenu.map(
                (data, index) => (
                  <div
                    key={data.id}
                    className={styles.list}
                    onClick={() => {
                      if (navigateEditMode) {
                        dispatch(editModeToggleHandler(true));
                      }
                    }}>
                    {!navigateEditMode && (
                      <Link to={data.link}>
                        <div
                          onClick={(e) => {
                            handleShowList(index);
                            handleClickEnterpriseLink(e, data.link);
                          }}
                          className={`${styles.serviceBtn} ${
                            isTdpItemActive(data) && styles.active
                          }`}>
                          {data.icon}
                          <div className={styles.serviceBtnContent}>
                            {data.name}
                          </div>
                        </div>
                      </Link>
                    )}
                    {navigateEditMode && (
                      <div
                        onClick={() => {
                          handleShowList(index);
                        }}
                        className={`${styles.serviceBtn} ${
                          isTdpItemActive(data) && styles.active
                        }`}>
                        {data.icon}
                        <div className={styles.serviceBtnContent}>{data.name}</div>
                      </div>
                    )}
                  </div>
                )
              )}
            </>
          )}

          {canAccessConsultations && (
            <>
              <div
                className={styles.groupHeader}
                onClick={() => toggleKeystoneGroup("registration")}>
                <div className={styles.groupHeaderTitle}>報名</div>
                <MdKeyboardArrowDown
                  className={`${styles.groupHeaderIcon} ${
                    keystoneOpenGroups.registration ? styles.groupHeaderOpen : ""
                  }`}
                />
              </div>
              {keystoneOpenGroups.registration &&
                menuAdminRegistration
                  .filter(
                    (data) =>
                      isWorkspaceAdminEmail || data.id === "admin-consultations"
                  )
                  .map((data) => (
                  <div key={data.id} className={styles.list}>
                    <Link to={data.link}>
                      <div
                        className={`${styles.serviceBtn} ${
                          location.pathname.includes(data.link) && styles.active
                        }`}>
                        {data.icon}
                        <div className={styles.serviceBtnContent}>{data.name}</div>
                      </div>
                    </Link>
                  </div>
                ))}
            </>
          )}

          {showTdpFinanceSection && (
            <>
              <div
                className={styles.groupHeader}
                onClick={() => toggleKeystoneGroup("finance")}>
                <div className={styles.groupHeaderTitle}>財務管理</div>
                <MdKeyboardArrowDown
                  className={`${styles.groupHeaderIcon} ${
                    keystoneOpenGroups.finance ? styles.groupHeaderOpen : ""
                  }`}
                />
              </div>
              {keystoneOpenGroups.finance &&
                tdpFinanceMenu.map((data, index) => (
                  <div
                    key={data.id}
                    className={styles.list}
                    onClick={() => {
                      if (navigateEditMode) {
                        dispatch(editModeToggleHandler(true));
                      }
                    }}>
                    {!navigateEditMode && (
                      <Link to={data.link}>
                        <div
                          onClick={(e) => {
                            handleShowList(index);
                            handleClickEnterpriseLink(e, data.link);
                          }}
                          className={`${styles.serviceBtn} ${
                            isTdpItemActive(data) && styles.active
                          }`}>
                          {data.icon}
                          <div className={styles.serviceBtnContent}>
                            {data.name}
                          </div>
                        </div>
                      </Link>
                    )}
                    {navigateEditMode && (
                      <div
                        onClick={() => {
                          handleShowList(index);
                        }}
                        className={`${styles.serviceBtn} ${
                          isTdpItemActive(data) && styles.active
                        }`}>
                        {data.icon}
                        <div className={styles.serviceBtnContent}>{data.name}</div>
                      </div>
                    )}
                  </div>
                ))}
            </>
          )}

        </div>

        <div className={styles.naviBottom}>
          <div className={styles.adminBlock}>
            <div className={styles.adminFlexLeft}>
              <div className={styles.adminTitle}>
                {auth?.roles.find((item) => item === "workspace.admin") &&
                  "Workspace Admin"}
                {auth?.roles.find((item) => item === "workspace.user") &&
                  !auth?.roles.find((item) => item === "workspace.admin") &&
                  !auth?.roles.find((item) => item === "workspace.tdp") &&
                  "Workspace User"}
                {auth?.roles.find((item) => item === "workspace.tdp") &&
                  (auth?.email === "workspace+manage@adbert.com.tw"
                    ? "Workspace 管理層"
                    : auth?.email === "workspace+marketing@adbert.com.tw"
                    ? "Workspace 行銷"
                    : auth?.email === "workspace+ceo@adbert.com.tw"
                    ? "Workspace CEO 辦公室"
                    : auth?.email === "workspace+ai@adbert.com.tw"
                    ? "Workspace AI Team"
                    : "Workspace Keystone")}
              </div>
              <div className={styles.adminName}>
                {auth?.name === "workspace.tdp"
                  ? "Keystone"
                  : auth?.name === "workspace.admin"
                  ? "Admin"
                  : auth?.name}
              </div>
            </div>
            <div className={styles.adminFlexRight}>
              <div className={styles.adminLastName}>
                {auth?.name?.substr(0, 1)}
              </div>
            </div>
          </div>
          <Button type='primary' title='登出' onClick={logOut} fullWidth />
        </div>
      </div>
    </>
  );
};

export default LeftNavigation;
